import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-create-details.module.scss";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import VelavuSelect from "../../../../elements/velavu-select";
import {
	getAvailableFloors,
	getAvailableSiteFloors,
	getDefaultFloor,
} from "../../../../helper/floor-helper";
import VelavuInput from "../../../../elements/velavu-input";
import { VelavuFloor } from "velavu-js-api";
import VelavuButton from "../../../../elements/velavu-button";
import VelavuNotice from "../../../../elements/velavu-notice/velavu-notice";
import { makeStyleable } from "../../../../helper/icon-helper";
import IconError from "../../../../dynamicicons/icon-error";
import { FloorInputInfo } from "../floor-input/floor-input-info";

export interface FloorCreateDetailsProps {
	existingFloors: VelavuFloor[];
	onClose?: () => void;
	onSubmit?: (floorNum: number, floorName: string) => void;
}

export function FloorCreateDetails(props: FloorCreateDetailsProps) {
	const { t } = useTranslation();
	const [floorNum, setFloorNum] = useState<number>(() =>
		getDefaultFloor(getAvailableSiteFloors(props.existingFloors)),
	);

	const [floorName, setFloorName] = useState("");
	const cleanFloorName = useMemo(() => floorName.trim(), [floorName]);

	const propsOnSubmit = props.onSubmit;
	const onSubmit = useCallback(() => {
		propsOnSubmit?.(floorNum, cleanFloorName);
	}, [floorNum, cleanFloorName, propsOnSubmit]);

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.floor_create.upload_header")}
				onClose={props.onClose}
			/>

			<div className={styles.content}>
				<h1 className={styles.label}>
					{t("dashboard.floor_create.details_question")}
				</h1>

				<FloorInputInfo
					existingFloors={props.existingFloors}
					level={floorNum}
					onChangeLevel={setFloorNum}
					name={floorName}
					onChangeName={setFloorName}
				/>

				<VelavuButton
					label={t("common.next")}
					disabled={cleanFloorName.length === 0}
					fullWidth
					onClick={onSubmit}
				/>
			</div>
		</PinnedList>
	);
}
